(function () {
  const settings = window.klaviyoBisSettings || {
    account: 'SjNwt2',
    platform: 'shopify',
    apiHostname: 'a.klaviyo.com',
    modal: {
      headline: '{product_name}',
      body_content: 'Register to receive a notification when this item comes back in stock.',
      email_field_label: 'Email',
      button_label: 'Notify me when available',
      subscription_success_label: "You're in! We'll let you know when it's back.",
      button_background_color: '#439fdb',
      button_text_color: '#fff',
    },
  };

  function getActiveBisAnchor() {
    const openModal = document.querySelector('quick-add-modal[open]');
    if (openModal) {
      return openModal.querySelector('#klaviyo-bis-anchor');
    }
    return document.querySelector('product-info #klaviyo-bis-anchor, main #klaviyo-bis-anchor');
  }

  function decorateKlaviyoQuickViewTriggers(anchor) {
    if (!anchor) return;

    const scope = anchor.closest('product-info') || anchor.closest('quick-add-modal') || document;
    const handle =
      anchor.closest('.klaviyo-product-container')?.dataset.klaviyoHandle ||
      scope.querySelector('variant-selects[data-product-handle]')?.dataset.productHandle ||
      scope.querySelector('[data-product-handle]')?.dataset.productHandle;

    const variantInput = anchor.querySelector('input[name="id"]');
    const trigger = anchor.querySelector('.klaviyo-bis-trigger');
    const container = anchor.closest('.klaviyo-product-container');

    if (variantInput && !variantInput.id) {
      variantInput.id = `KlaviyoVariantInput-${variantInput.value || Date.now()}`;
    }

    if (handle && container) {
      container.dataset.klaviyoHandle = handle;
    }

    if (!trigger || !variantInput?.id) return;

    if (handle) {
      trigger.dataset.klaviyoHandle = handle;
    }
    trigger.dataset.klaviyoQuickviewVariant = `#${CSS.escape(variantInput.id)}`;
  }

  function isSoldOutVariantSelected() {
    const anchor = getActiveBisAnchor();
    if (!anchor) return false;
    const submit = anchor.querySelector('.product-form__submit');
    if (!submit) return false;
    return submit.dataset.variantState === 'sold-out' || submit.hasAttribute('disabled');
  }

  function syncKlaviyoVariant() {
    const anchor = getActiveBisAnchor();
    if (!anchor) return;
    const input = anchor.querySelector('input[name="id"]');
    if (!input) return;
    input.disabled = false;
    decorateKlaviyoQuickViewTriggers(anchor);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function getProductHandleFromScope(scope) {
    const anchor = scope.querySelector('#klaviyo-bis-anchor');
    decorateKlaviyoQuickViewTriggers(anchor);
    return (
      scope.querySelector('.klaviyo-bis-trigger')?.dataset.klaviyoHandle ||
      scope.querySelector('.klaviyo-product-container')?.dataset.klaviyoHandle ||
      scope.querySelector('variant-selects[data-product-handle]')?.dataset.productHandle
    );
  }

  function getSelectedVariantIdFromScope(scope) {
    const input = scope.querySelector('#klaviyo-bis-anchor input[name="id"]');
    if (!input) return null;
    input.disabled = false;
    return input.value;
  }

  function fetchProductByHandle(handle) {
    const root = window.Shopify?.routes?.root || '/';
    const normalizedRoot = root.endsWith('/') ? root : `${root}/`;
    const url = `${normalizedRoot}products/${encodeURIComponent(handle)}.js`;
    return fetch(url).then((response) => {
      if (!response.ok) throw new Error('Unable to load product details.');
      return response.json();
    });
  }

  function getUnavailableVariants(product) {
    const unavailable = (product.variants || []).filter((variant) => variant.available === false);
    return unavailable.length ? unavailable : product.variants || [];
  }

  function ensureKlaviyoModal() {
    let root = document.getElementById('klaviyo-bis-modal-host');
    if (root) return root;

    const modalSettings = settings.modal || {};

    root = document.createElement('div');
    root.id = 'klaviyo-bis-modal-host';
    root.className = 'klaviyo-bis-modal-host';
    root.innerHTML = `
      <div class="klaviyo-bis-modal-host__overlay" data-klaviyo-bis-close></div>
      <div id="klaviyo-bis-modal" class="klaviyo-bis-modal-host__dialog" role="dialog" aria-modal="true">
        <button type="button" class="klaviyo-bis-modal-host__close klaviyo-bis-close" data-klaviyo-bis-close aria-label="Close">&times;</button>
        <h3 class="klaviyo-bis-modal-host__title modal-title"></h3>
        <p class="klaviyo-bis-modal-host__body"></p>
        <form class="klaviyo-bis-modal-host__form">
          <div class="klaviyo-bis-modal-host__variant-wrap" id="variant_select">
            <select id="variants" name="variant" class="klaviyo-bis-modal-host__select form-control input-lg"></select>
          </div>
          <div class="klaviyo-bis-modal-host__email-wrap">
            <input type="email" id="email" name="email" class="klaviyo-bis-modal-host__email form-control input-lg" required autocomplete="email">
          </div>
          <button type="submit" class="klaviyo-bis-modal-host__submit btn btn-success btn-lg col-xs-12"></button>
          <div id="error_message" class="klaviyo-bis-modal-host__error alert alert-danger" hidden></div>
          <div id="completed_message" class="klaviyo-bis-modal-host__success alert alert-success" hidden></div>
        </form>
      </div>
    `;
    document.body.appendChild(root);

    root.style.setProperty('--klaviyo-bis-btn-bg', modalSettings.button_background_color || '#439fdb');
    root.style.setProperty('--klaviyo-bis-btn-color', modalSettings.button_text_color || '#fff');

    root.addEventListener('click', (event) => {
      if (event.target.closest('[data-klaviyo-bis-close]')) {
        closeKlaviyoModal();
      }
    });

    root.querySelector('form').addEventListener('submit', onKlaviyoModalSubmit);

    return root;
  }

  function closeKlaviyoModal() {
    const root = document.getElementById('klaviyo-bis-modal-host');
    if (!root) return;
    root.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
  }

  function openKlaviyoModal(product, selectedVariantId) {
    const modalSettings = settings.modal || {};
    const root = ensureKlaviyoModal();
    const form = root.querySelector('form');
    const title = root.querySelector('.modal-title');
    const body = root.querySelector('.klaviyo-bis-modal-host__body');
    const email = root.querySelector('#email');
    const select = root.querySelector('#variants');
    const variantWrap = root.querySelector('#variant_select');
    const submit = root.querySelector('.klaviyo-bis-modal-host__submit');
    const error = root.querySelector('#error_message');
    const success = root.querySelector('#completed_message');

    const unavailableVariants = getUnavailableVariants(product);
    const headline = (modalSettings.headline || '{product_name}').replace('{product_name}', product.title);
    const bodyContent = (modalSettings.body_content || '').replace('{product_name}', product.title);

    title.textContent = headline;
    body.textContent = bodyContent;
    email.placeholder = modalSettings.email_field_label || 'Email';
    email.value = '';
    submit.textContent = modalSettings.button_label || 'Notify me when available';
    submit.disabled = false;
    form.hidden = false;
    error.hidden = true;
    success.hidden = true;
    success.textContent =
      modalSettings.subscription_success_label || "You're in! We'll let you know when it's back.";

    select.innerHTML = unavailableVariants
      .map((variant) => `<option value="${variant.id}">${variant.title}</option>`)
      .join('');

    if (selectedVariantId && unavailableVariants.some((v) => String(v.id) === String(selectedVariantId))) {
      select.value = String(selectedVariantId);
    }

    variantWrap.hidden = unavailableVariants.length <= 1;

    root.dataset.productId = String(product.id);
    root.classList.add('is-open');
    document.body.classList.add('overflow-hidden');
    window.setTimeout(() => email.focus(), 50);
  }

  function onKlaviyoModalSubmit(event) {
    event.preventDefault();

    const root = document.getElementById('klaviyo-bis-modal-host');
    if (!root) return;

    const form = event.currentTarget;
    const emailInput = form.querySelector('#email');
    const variantSelect = form.querySelector('#variants');
    const submit = form.querySelector('.klaviyo-bis-modal-host__submit');
    const error = root.querySelector('#error_message');
    const success = root.querySelector('#completed_message');
    const email = emailInput.value.trim();
    const variantId = variantSelect.value;

    error.hidden = true;
    success.hidden = true;

    if (!email || !email.includes('@')) {
      error.textContent = 'Please enter a valid email address.';
      error.hidden = false;
      return;
    }

    submit.disabled = true;

    fetch(`https://${settings.apiHostname}/client/back-in-stock-subscriptions/?company_id=${settings.account}`, {
      method: 'POST',
      headers: {
        revision: '2024-02-15',
        'Content-Type': 'application/json',
        'X-Klaviyo-Onsite': '1',
      },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: { email },
              },
            },
            channels: ['EMAIL'],
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: `$${settings.platform}:::$default:::${variantId}`,
              },
            },
          },
        },
      }),
    })
      .then((response) => {
        if (!response.ok) throw new Error('Subscription failed. Please try again.');
        form.hidden = true;
        success.hidden = false;
      })
      .catch((submitError) => {
        error.textContent = submitError.message || 'Something went wrong. Please try again.';
        error.hidden = false;
        submit.disabled = false;
      });
  }

  function openQuickViewKlaviyoPopup(quickAddModal, trigger) {
    const handle = getProductHandleFromScope(quickAddModal);
    const variantId = getSelectedVariantIdFromScope(quickAddModal);

    if (!handle) {
      console.error('[Klaviyo BIS] Missing product handle in quick view.');
      return;
    }

    trigger.classList.add('loading');
    trigger.setAttribute('aria-busy', 'true');

    fetchProductByHandle(handle)
      .then((product) => {
        openKlaviyoModal(product, variantId);
      })
      .catch((error) => {
        console.error('[Klaviyo BIS]', error);
      })
      .finally(() => {
        trigger.classList.remove('loading');
        trigger.removeAttribute('aria-busy');
      });
  }

  document.addEventListener(
    'click',
    (event) => {
      const quickAddModal = event.target.closest('quick-add-modal[open]');
      if (!quickAddModal) return;

      const trigger = event.target.closest('.klaviyo-bis-trigger');
      if (!trigger) return;

      event.preventDefault();
      event.stopPropagation();

      openQuickViewKlaviyoPopup(quickAddModal, trigger);
    },
    true
  );

  function reloadKlaviyoOnsite() {
    return new Promise((resolve) => {
      if (!window.loadKlaviyoBackInStock) {
        resolve();
        return;
      }

      const existing = document.querySelector('script[src*="a.klaviyo.com/media/js/onsite/onsite.js"]');
      if (existing) existing.remove();

      delete window.klaviyo;
      delete window._klOnsite;
      delete window.klaviyoBIS;
      window.__klaviyoBISConfigApplied = false;

      const script = document.createElement('script');
      script.src = 'https://a.klaviyo.com/media/js/onsite/onsite.js';
      script.async = true;
      script.onload = () => {
        window.setTimeout(() => {
          window.loadKlaviyoBackInStock();
          syncKlaviyoVariant();
          resolve();
        }, 300);
      };
      script.onerror = () => resolve();
      document.head.appendChild(script);
    });
  }

  function refreshKlaviyoBackInStock() {
    window.setTimeout(() => {
      const anchor = getActiveBisAnchor();
      if (!anchor) return;
      decorateKlaviyoQuickViewTriggers(anchor);

      if (document.querySelector('quick-add-modal[open]')) return;

      if (isSoldOutVariantSelected()) {
        reloadKlaviyoOnsite();
      }
    }, 200);
  }

  window.refreshKlaviyoBackInStock = refreshKlaviyoBackInStock;

  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, () => {
      const anchor = getActiveBisAnchor();
      decorateKlaviyoQuickViewTriggers(anchor);

      if (document.querySelector('quick-add-modal[open]')) return;

      if (!isSoldOutVariantSelected()) return;
      reloadKlaviyoOnsite().then(syncKlaviyoVariant);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (window.loadKlaviyoBackInStock) {
      window.loadKlaviyoBackInStock();
    }

    const anchor = getActiveBisAnchor();
    if (anchor) {
      decorateKlaviyoQuickViewTriggers(anchor);
    }

    if (isSoldOutVariantSelected() && !document.querySelector('quick-add-modal[open]')) {
      syncKlaviyoVariant();
      refreshKlaviyoBackInStock();
    }
  });
})();
